import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'fuse-ui/components/TextField';

const DomainGroupingTextField = ( { selectedGroupName, setSelectedGroupName } ) => {
    const changeHandler = ( event ) => setSelectedGroupName( event.target.value );

    return (
        <TextField
            value={selectedGroupName}
            fullWidth
            inputProps={{
                maxLength: 50
            }}
            label="Group Name"
            onChange={changeHandler}
        />
    );
};

DomainGroupingTextField.propTypes = {
    selectedGroupName: PropTypes.string.isRequired,
    setSelectedGroupName: PropTypes.func.isRequired
};
export default DomainGroupingTextField;
